<template>
  <div class="signup">
    <div class="title">
      <p style="height: 55px;"></p>
      <!-- <img style="width:188px" src="../../assets/image/match/signup-title.png" alt=""> -->
    </div>
    <div class="concat-list" style="display:flex;">
      <div class="concat-box">
        <div class="pic-box">
          <br>
          <!-- <img src="@/assets/image/图标1.png" alt=""/> -->
          <div>联系电话</div>
          <div>胡女士：13755163377（微信同号）</div>
          <div>联系邮箱</div>
          <div>didaward2022@163.com</div>
        </div>

        <div class="pic-box">
          <br>
          <!-- <img src="@/assets/image/图标3.png" alt=""/> -->
          <div>关注官方微信</div><br>
          <div>DIDAward</div>
          <div>湖南旭麓新材料科技有限公司</div>
        </div>
      </div>
      <div style="margin-left:200px;margin-top:70px">
        <!-- <img style="width: 304px" src="../../assets/image/match/signup-kh.png" alt=""> -->
        <div class="signupbtn" @click="toPage">立即报名</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {};
  },
  methods: {
    toPage() {
      this.$router.push({
        path: '/Signup'
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.signup {
  height: 748px;
	// background: url('../../assets/image/match/signup-bg.jpg') no-repeat center top;

  .title {
		padding-top: 160px;
		text-align: center;
		margin-bottom: 52px;
	}

  .text {
    // text-align: center;
    margin: auto;
    width: 580px;
    // font-weight: bold;
    line-height: 50px;
    text-indent: 2em;
    font-size: 25px;
    color: rgb(31, 0, 2)
  }

  .pic-box {
    text-align: center;
    margin-top: 100px;
    color: black;
    flex: 1;
    line-height: 26px;
  }

  .signupbtn {
    color: white;
    background-color: rgb(194, 70, 72);
    width: 267px;
    height: 80px;
    text-align: center;
    line-height: 80px;
    font-size: 28px;
    cursor: pointer;
    margin-top: 190px;
  }
}
.concat-list {
  height: 492px;
	// background: url('../../assets/image/match/concat-bg.jpg') no-repeat center top;
}
.concat-box {
  display:flex;
  width: 610px;
  align-items: center;justify-content: center;
  img {width: 46px;margin-bottom: 10px;}
}
</style>



// WEBPACK FOOTER //
// src/components/Match/signup.vue